<script>
export default {
  props: {
    type: { type: String, required: true },
    connected: { type: Boolean, required: true },
    displayname: { type: String, required: true },
    tagline: { type: String, required: true },
    logourl: { type: String, required: true },
    actionurl: { type: String, required: true },
  },
  data() {
    return {
      userOrg: '',
      addDialog: false,
      edit: false,
      create: false,
      resourceMenuItem: null,
      resourceItem: null,
    }
  },
}
</script>

<template>
  <v-card :class="$style.cardStyle" outlined>
    <v-img height="200" width="200" :src="logourl" />
    <p :class="$style.cardDesc">{{ displayname }}</p>
    <a v-if="!connected" :href="actionurl" target="_blank">
      <v-btn :class="['primary-btn', connected && $style.connectedBtn]">
        connect
      </v-btn>
    </a>
    <v-btn v-else :class="['primary-btn', connected && $style.connectedBtn]">
      connected
    </v-btn>
    <div :class="$style.disconnectDiv">
      <a v-if="connected" :href="actionurl" target="_blank">
        <h5 class="text-center">Disconnect</h5>
      </a>
    </div>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.cardStyle {
  width: 340px;
  padding: 30px !important;
  margin: 10px 10px 20px 10px;
  text-align: center;
  border-radius: 9px !important;
  box-shadow: 0 0 6px rgba(146, 191, 231, 0.6);
}
.cardDesc {
  padding-top: 10px;
  padding-bottom: 10px !important;
  margin-bottom: 0 !important;
  font-size: 14px;
  text-align: center;
  vertical-align: middle;
}
.connectedBtn {
  padding: 12px 35px !important;
  font-family: 'Open Sans', 'Inter', sans-serif;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 21px;
  color: #fff !important;
  text-transform: inherit !important;
  pointer-events: none;
  cursor: not-allowed !important;
  background-color: #1ab394 !important;
  border: none;
  border-radius: 30px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.disconnectDiv {
  height: 30px;
  padding-top: 10px;
}
.disconnectDiv a {
  text-decoration: none;
}
.disconnectDiv h5 {
  font-family: 'Open Sans', 'Inter', sans-serif;
  font-size: 14px !important;
  font-weight: 400 !important;
}
@media screen and (max-width: 1600px) {
  .cardStyle {
    padding: 30px 20px !important;
  }
}

@media screen and (max-width: 959px) {
  .cardStyle {
    padding: 30px !important;
  }
}
@media screen and (max-width: 479px) {
  .cardStyle {
    padding: 30px !important;
  }
}
</style>
